import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AuthShell from '../components/AuthShell';
import { apiFetch, ApiError } from '../lib/api';

export default function Reset() {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get('t') || '';
    const [pw, setPw]   = useState('');
    const [pw2, setPw2] = useState('');
    const [err, setErr] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    async function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        setErr(null);
        if (pw.length < 8) return setErr(t('auth.errors.passwordTooShort'));
        if (pw !== pw2)    return setErr(t('auth.errors.passwordsMismatch'));
        if (!token)        return setErr(t('auth.errors.tokenInvalid'));
        setBusy(true);
        try {
            await apiFetch('/api/auth/reset', {
                method: 'POST', noAuth: true,
                body: { token, password: pw },
            });
            setDone(true);
            setTimeout(() => navigate('/'), 1500);
        } catch (e) {
            setErr(e instanceof ApiError ? e.message : t('auth.errors.unknown'));
        } finally { setBusy(false); }
    }

    return (
        <AuthShell
            eyebrow={t('brand.tagline')}
            title={t('auth.reset.title')}
            backTo="/"
        >
            {done ? (
                <p className="text-center text-ink-on font-body py-6">{t('auth.reset.updated')}</p>
            ) : (
                <form onSubmit={onSubmit} className="space-y-5" noValidate>
                    <label className="block">
                        <span className="field-label">{t('auth.activate.newPw')}</span>
                        <input className="field-input" type="password" autoComplete="new-password"
                               value={pw} onChange={(e) => setPw(e.target.value)} required />
                    </label>
                    <label className="block">
                        <span className="field-label">{t('auth.activate.confirm')}</span>
                        <input className="field-input" type="password" autoComplete="new-password"
                               value={pw2} onChange={(e) => setPw2(e.target.value)} required />
                    </label>
                    {err && <div role="alert" className="text-sm text-ember pl-3 border-l-2 border-ember py-1">{err}</div>}
                    <button type="submit" className="btn btn-primary w-full" disabled={busy}>
                        {busy ? t('common.loading') : t('auth.reset.cta')}
                    </button>
                </form>
            )}
            <div className="mt-6 text-center">
                <Link to="/" className="btn-link text-sm">{t('common.back')}</Link>
            </div>
        </AuthShell>
    );
}
